module.exports = __webpack_public_path__ + "img/8-sdg-border@2x.821ad1fc.png";